// React
import { Fragment, useContext } from "react";

// Contexts
import { AccountContext } from "contexts";

// Form
import { useFormContext, useWatch } from "react-hook-form";

// Types
import type { FormType } from "../utils";

// Utils
import { convertNumber, useCoaByCode } from "utils";

export function JournalListOnPrint(): JSX.Element {
  return <></>;
}

function PaymentAccount(): JSX.Element {
  // Hooks
  const account = useContext(AccountContext);
  const tracking = useCoaByCode("LA07");

  // Form
  const { control } = useFormContext<FormType>();
  const coa_id = useWatch({
    control,
    name: "coa_id",
  });
  const payment_amount = useWatch({
    control,
    name: "payment_amount",
  });

  const coa = account.data.find((item) => item.value === coa_id)?.label ?? "-";
  const formattedAmount = convertNumber(payment_amount).intoCurrency;

  if (coa_id && payment_amount) {
    return (
      <Fragment>
        <tr>
          <td>{tracking.data}</td>
          <td className="text-right">{formattedAmount}</td>
          <td className="text-right"></td>
        </tr>

        <tr>
          <td>{coa}</td>
          <td className="text-right"></td>
          <td className="text-right text-error">{formattedAmount}</td>
        </tr>
      </Fragment>
    );
  }

  return <Fragment />;
}

function PaymentDeposit(): JSX.Element {
  // Hooks
  const tracking = useCoaByCode("LA07");
  const asset = useCoaByCode("LA09");

  // Form
  const { control } = useFormContext<FormType>();
  const deposit_amount = useWatch({
    control,
    name: "deposit_amount",
  });

  const formattedAmount = convertNumber(deposit_amount).intoCurrency;

  if (deposit_amount) {
    return (
      <Fragment>
        <tr>
          <td>{tracking.data}</td>
          <td className="text-right">{formattedAmount}</td>
          <td className="text-right"></td>
        </tr>

        <tr>
          <td>{asset.data}</td>
          <td className="text-right"></td>
          <td className="text-right text-error">{formattedAmount}</td>
        </tr>
      </Fragment>
    );
  }

  return <Fragment />;
}

JournalListOnPrint.PaymentAccount = PaymentAccount;
JournalListOnPrint.PaymentDeposit = PaymentDeposit;
